const MEMORY_GRID = [
  { value: '3x4', label: '3×4 (12 cards)' },
  { value: '4x4', label: '4×4 (16 cards)' },
  { value: '4x6', label: '4×6 (24 cards)' },
];

const FLIP_SPEED = [
  { value: 'normal', label: 'Normal (0.5s)' },
  { value: 'fast', label: 'Fast (0.3s)' },
  { value: 'slow', label: 'Slow (1.0s)' },
];

const SLIDING_GRID = [
  { value: '3x3', label: '3×3 (Standard)' },
  { value: '4x4', label: '4×4 (Hard)' },
  { value: '5x5', label: '5×5 (Expert)' },
];

const BUBBLE_LIKE = [
  { key: 'grid_cols', label: 'Grid columns', type: 'number', min: 4, max: 10, step: 1, default: '6' },
  { key: 'colors_count', label: 'Colors count', type: 'number', min: 2, max: 8, step: 1, default: '4' },
  { key: 'fall_interval', label: 'Fall interval (s)', type: 'number', min: 1, max: 120, step: 0.5, default: '5' },
  { key: 'initial_rows', label: 'Initial rows', type: 'number', min: 0, max: 8, step: 1, default: '3' },
  { key: 'min_match', label: 'Min match', type: 'number', min: 2, max: 5, step: 1, default: '3' },
  { key: 'special_chance', label: 'Special chance (0–1)', type: 'number', min: 0, max: 1, step: 0.01, default: '0.07' },
];

const GAME_CONFIG_FIELDS = {
  match_pairs: [
    { key: 'grid_size', label: 'Grid size', type: 'select', options: MEMORY_GRID, default: '3x4' },
    { key: 'flip_speed', label: 'Flip speed', type: 'select', options: FLIP_SPEED, default: 'normal' },
    { key: 'win_message', label: 'Win message', type: 'text', default: 'Mashallah! Great Job!' },
  ],
  sliding_puzzle: [
    { key: 'grid_size', label: 'Grid', type: 'select', options: SLIDING_GRID, default: '3x3' },
  ],
  catch_star: [
    { key: 'lives', label: 'Lives', type: 'number', min: 1, max: 10, step: 1, default: '3' },
    { key: 'time_limit', label: 'Time limit (s)', type: 'number', min: 10, max: 300, step: 1, default: '60' },
    { key: 'spawn_interval', label: 'Spawn interval (s)', type: 'number', min: 0.2, max: 5, step: 0.1, default: '0.75' },
    { key: 'spawn_interval_range', label: 'Spawn interval range', type: 'number', min: 0, max: 2, step: 0.1, default: '0.4' },
  ],
  color_match: BUBBLE_LIKE,
  bubble_shooter: BUBBLE_LIKE,
  block_stack: [
    { key: 'grid_cols', label: 'Grid columns', type: 'number', min: 6, max: 12, step: 1, default: '10' },
    { key: 'grid_rows', label: 'Grid rows', type: 'number', min: 14, max: 24, step: 1, default: '18' },
    { key: 'initial_drop_interval', label: 'Initial drop interval (s)', type: 'number', min: 0.3, max: 2.5, step: 0.1, default: '1' },
    { key: 'lines_per_speed_up', label: 'Lines per speed up', type: 'number', min: 1, max: 10, step: 1, default: '3' },
    { key: 'speed_multiplier', label: 'Speed multiplier', type: 'number', min: 0.7, max: 0.98, step: 0.01, default: '0.92' },
    { key: 'min_drop_interval', label: 'Min drop interval (s)', type: 'number', min: 0.08, max: 0.5, step: 0.01, default: '0.15' },
  ],
};

export function getGameConfigFields(gameType) {
  if (!gameType || !GAME_CONFIG_FIELDS[gameType]) return [];
  return GAME_CONFIG_FIELDS[gameType];
}

export function seedGameConfigValues(gameType, serverConfig = {}) {
  const fields = getGameConfigFields(gameType);
  const out = {};
  for (const f of fields) {
    const raw = serverConfig[f.key];
    out[f.key] = raw != null && String(raw) !== '' ? String(raw) : String(f.default);
  }
  return out;
}

export function buildConfigForSave(gameType, serverConfig, editedValues) {
  const fields = getGameConfigFields(gameType);
  const base = { ...(serverConfig && typeof serverConfig === 'object' ? serverConfig : {}) };
  for (const f of fields) {
    const v = editedValues[f.key];
    base[f.key] = v != null && String(v) !== '' ? String(v) : String(f.default);
  }
  return base;
}
